import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from '../locales/en/translation.json';
import mmTranslation from '../locales/mm/translation.json';

// Check URL parameter for language
const getLanguageFromURL = (): string | null => {
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang');

    // Map 'my' to 'mm' for Myanmar language
    if (langParam === 'my') {
      return 'mm';
    }

    return langParam;
  }
  return null;
};

// Get language from URL parameter if available
const urlLanguage = getLanguageFromURL();

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      mm: {
        translation: mmTranslation,
      },
    },
    // Only set lng if URL parameter exists, otherwise let LanguageDetector handle it
    ...(urlLanguage && { lng: urlLanguage }),
    fallbackLng: 'en',
    supportedLngs: ['en', 'mm'], // Explicitly define supported languages

    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      lookupQuerystring: 'lang',
    },

    interpolation: {
      escapeValue: false, // React already handles escaping
    },
  });

// Expose i18n to window for debugging
if (typeof window !== 'undefined') {
  (window as typeof window & { i18n: typeof i18n }).i18n = i18n;
}

export default i18n;
